<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer" @changeIsOperationPossible="changeIsOperationPossible">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color mh-550 shadow">
          <div class="base-color mh-550 shadow">
            <div class="p-2 position-relative" id="content-area-inner">
              <h4 class="mt-2 text-center">フラワーコーディネートシート</h4>
              <div class="position-absolute small" style="top: 40px; right: 10px;">
                <span>No.</span>{{estimateData('form', 'projectNumber')}}
              </div>
              <form method="post" action="#" class="form-horizontal">
                <div class="p-4">
                    <div class="mb-2 text-right p-0 small" >
                      <span id="plan" class="p-0 d-inline-block" v-if="estimateData('form', 'plan')">{{estimateData('form', 'plan')}}</span>
                      <span id="plan" class="p-0 d-inline-block" v-if="estimateData('form', 'pack')">{{estimateData('form', 'pack')}}</span>
                    </div>
                  <div class="form-group row mb-2">
                    <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                    <div class="col-sm-6 row small">
                      <!-- <div class="col-3 col-sm-4 p-0"><span>ご両家様名</span></div> -->
                      <div class="col-4 col-sm-4 p-0"><span>施設名</span></div>
                      <!-- #55 2022.09.09 end -->
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                      <!-- <div class="col-8 col-sm-7 text-break result-input" id="bothFamilyName"> {{estimateData('form', 'bothFamilyName')}} <span>ご両家様</span></div> -->
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="bothFamilyName"> {{estimateData('form', 'facilityName')}}</div>
                      <!-- #55 2022.09.09 end -->
                    </div>
                    <div class="col-sm-6 row small">
                      <div class="col-4 p-0"><span>ご両家様名</span></div>
                      <div class="col-1 p-0">：</div>
                      <div class="col-7 p-0 text-break result-input" id="bothFamilyName"> {{estimateData('form', 'bothFamilyName')}} <span>ご両家様</span></div>
                    </div>
                    <div class="small">
                      <div class="col-12 p-0 text-break result-input" id="attendance" v-if="estimateData('form', 'attendance')"> {{estimateData('form', 'attendance')}}名 </div>
                    </div>
                    <!--<div class="col-sm-6 text-right p-0" >
                      <span id="plan" class="small p-0 d-inline-block" v-if="estimateData('form', 'plan')">{{estimateData('form', 'plan')}}</span>
                      <span id="plan" class="small p-0 d-inline-block" v-if="estimateData('form', 'pack')">{{estimateData('form', 'pack')}}</span>
                    </div>-->
                  </div>
                  <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                  <div class="form-group row mb-2">
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>挙式日</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="weddingDate"> {{changeDateFormat('form', 'weddingDate')}} </div>
                    </div>
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>前撮り日</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="preShootDay"> {{changeDateFormat('form', 'preShootDay')}} </div>
                    </div>
                  </div>
                  <div class="form-group row mb-2">
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>挙式スタイル</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="weddingStyle"> {{estimateData('form', 'weddingStyle')}} </div>
                    </div>
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>挙式時間</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="nuptialTime"> {{estimateData('form', 'nuptialTime')}} </div>
                    </div>
                  </div>
                  <div class="form-group row mb-2">
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>披露宴会場名</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="venue"> {{estimateData('form', 'venue')}} </div>
                    </div>
                    <div class="col-sm-6 row small">
                      <div class="col-4 col-sm-4 p-0"><span>披露宴時間</span></div>
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="weddingTime"> {{estimateData('form', 'weddingTime')}} </div>
                    </div>
                  </div>
                  <!-- #55 2022.09.09 end -->
                  <div class="form-group row mb-2">
                    <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                    <div class="col-sm-6 row small">
                      <!-- <div class="col-3 col-sm-4 p-0"><span>打合せ日</span></div> -->
                      <div class="col-4 col-sm-4 p-0"><span>打合せ日</span></div>
                    <!-- #55 2022.09.09 end -->
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                      <!--  <div class="col-8 col-sm-7 text-break result-input" id="meetingDate"> {{estimateData('form', 'meetingDate')}} </div>-->
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="meetingDate"> {{changeDateFormat('form', 'meetingDate')}} </div>
                      <!-- #55 2022.09.09 end -->
                    </div>
                    <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                    <div class="col-sm-6 row small">
                      <!-- <div class="col-5 col-sm-4 p-0"><span>担当者（日比谷）</span></div> -->
                      <div class="col-4 col-sm-4 p-0"><span>プランナー</span></div>
                      <!-- #55 2022.09.09 end -->
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                      <!-- <div class="col-6 col-sm-7 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div> -->
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="plannerName"> {{estimateData('form', 'plannerName')}} </div>
                      <!-- #55 2022.09.09 end -->
                    </div>
                  </div>
                  <div class="form-group row mb-2">
                    <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                    <div class="col-sm-6 row small">
                      <!-- <div class="col-3 col-sm-4 p-0"><span>打合せ日</span></div> -->
                      <div class="col-4 col-sm-4 p-0"><span>明細種別</span></div>
                    <!-- #55 2022.09.09 end -->
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                      <!--  <div class="col-8 col-sm-7 text-break result-input" id="meetingDate"> {{estimateData('form', 'meetingDate')}} </div>-->
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="meetingType"> {{estimateData('form', 'meetingType')}} </div>
                      <!-- #55 2022.09.09 end -->
                    </div>
                    <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                    <div class="col-sm-6 row small">
                      <!-- <div class="col-5 col-sm-4 p-0"><span>担当者（日比谷）</span></div> -->
                      <div class="col-4 col-sm-4 p-0"><span>担当</span></div>
                      <!-- #55 2022.09.09 end -->
                      <div class="col-1 col-sm-1 p-0">：</div>
                      <!-- #55 2022.09.09 start フラワーコーディネートシートレイアウト変更 -->
                      <!-- <div class="col-6 col-sm-7 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div> -->
                      <div class="col-7 col-sm-7 p-0 text-break result-input" id="planner"> {{estimateData('form', 'planner')}} </div>
                      <!-- #55 2022.09.09 end -->
                    </div>
                  </div>
                </div>
              </form>
              <div class="m-0">
                <table class="table table-bordered small text-center estimate-table">
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 10%"></th>
                      <th style="width: 15%">中区分</th>
                      <th style="width: 20%">商品名</th>
                      <th style="width: 10%">商品単価<br>(税抜)</th>
                      <th style="width: 5%">割引(%)</th>
                      <th style="width: 5%">数量</th>
                      <th style="width: 10%">商品金額計<br>(税抜)</th>
                      <th style="width: 15%">備考</th>
                    </tr>
                  </thead>
                  <tbody v-for="(estimate, category) in estimateData('tableForCustomer')" :key="category">
                    <tr v-for="(item, index) in estimate" :key="index">
                      <td class="align-middle" :rowspan="Object.keys(estimate).length" v-if="index === 0">{{item['sectionL']}}</td>
                      <td :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{item['sectionM']}}</td>
                      <td :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{item['itemName']}}</td>
                      <td class="text-right" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')" v-if="'margin' in item && item['margin']">{{toCommaSeparated(item['margin'])}}</td>
                      <td class="text-right" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')" v-else>{{toCommaSeparated(item['itemPrice'])}}</td>
                      <td class="text-right" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{item['discount'] !== undefined && item['discount'] !== '' ? item['discount'] + '%' : ''}}</td>
                      <td class="text-right" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{item['quantity']}}</td>
                      <td class="text-right" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{toCommaSeparated(item['itemEstimatePriceTotal'])}}</td>
                      <td class="text-left word-pre-wrap" :style="(item['change'] ? 'background-color:#FFE4E1;' : '')">{{item['note']}}</td>
                    </tr>
                  </tbody>
                  <tbody class="border-bottom">
                  </tbody>
                </table>
              </div>
              <div class="row mt-3 p-3">
                <table class="table mb-1 col-8 col-sm-8" v-if="estimateData('form', 'totalPriceDisplay') && estimateData('form', 'totalPriceDisplay').includes('お客様見積に表示する')">
                  <tbody>
                    <tr class="mt-3">
                      <td class="p-2 small">{{estimateData('form', 'pack')}}合計</td>
                      <td class="p-2 text-right small">{{toCommaSeparated(estimateData('form', 'totalPlanPrice'))}}</td>
                    </tr>
                    <tr>
                      <td class="pr-2 pl-2 pt-0 pb-0 small" style="border-top: none;"></td>
                      <td class="pr-2 pl-2 pt-0 pb-0 text-right small" style="border-top: none;">{{estimateData('form', 'planRemarks')}}</td>
                    </tr>
                  </tbody>
                </table>
                <table class="table mb-0 col-8 col-sm-8">
                  <tbody>
                    <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                    <!-- <tr class="mt-3"> -->
                    <tr class="mt-3" v-if="estimateData('form', 'totalPriceExcTaxFlag') == '1'">
                    <!-- #66 2022/09/27 end -->
                      <td class="p-2">合計(税抜)</td>
                      <td class="p-2 text-right">{{toCommaSeparated(estimateData('form', 'taxExcludeTotal'))}}</td>
                    </tr>
                    <!-- #66 2022/09/05 start 税込金額表示制御対応 -->
                    <!-- <tr> -->
                    <!-- #66 2022/09/27 start 合計金額表示制御対応 -->
                    <!-- <tr v-if="estimateData('form', 'hiddenTotalPriceIncTaxFlag') != '表示しない'"> -->
                    <tr v-if="estimateData('form', 'totalPriceIncTaxFlag') == '1'">
                    <!-- #66 2022/09/27 end -->
                    <!-- #66 2022/09/05 end -->
                      <td class="p-2">合計(税込)</td>
                      <td class="p-2 text-right">{{toCommaSeparated(estimateData('form', 'taxIncludeTotal'))}}</td>
                    </tr>
                    <tr v-if="estimateData('form', 'pack') && estimateData('form', 'totalPriceText') && (estimateData('form', 'totalPriceExcTaxFlag') == '1' || estimateData('form', 'totalPriceIncTaxFlag') == '1')">
                      <td class="p-2"></td>
                      <td class="p-2 text-right" style="font-size: 65%; color: #adadff;">{{estimateData('form', 'totalPriceText')}}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-4 col-sm-4 pr-0">
                  <img class="border w-100" v-if="signImageData !== '' || estimateData('signImage')" :src="signImageData !== '' ? signImageData : estimateData('signImage')"/>
                  <div class="text-right text-right col-12 pr-0" v-if="signImageData !== '' || estimateData('signImage')">
                    {{signDate}}
                  </div>
                </div>
              </div>
              <div class="text-right" style="font-size: 9.6px">
                本日の打合せ内容ならびに、個人情報・画像の取り扱いについて&emsp;<br>ご確認いただいた旨、サインを頂戴しております。&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;<br>正式なお見積もりは、式場より提出されるものをご確認ください。
              </div>
              <transition>
                <div class="m-auto pt-3 pb-5 row" v-show="isShowSignForm">
                  <SignDrawCanvas
                    :allowDrawing="{isOperationPossible}"
                    :drawMode="drawMode"
                    :penColor="penColor"
                    @registDrawnImage="registDrawnImage"
                    @sendSignalingDraw="sendSignalingDraw"
                    ref="signDrawCanvas"/>
                <div class="col-sm-12 row px-0 mx-0 mt-3" style="border: 1px solid #dee2e6">
                  <a href="#" class="col-sm-5" style="align-items: center; display: flex; font-size: 1rem;" @click.prevent.stop="openTermPDF('personalInformation')">個人情報のお取り扱いについて</a>
                  <div class="col-sm-7 d-flex">
                    <label class="py-1 px-4 mb-0" style="font-size: 1rem;" for="personalInformationCheck">
                      <input type="checkbox" class="checkbox-scale-larger mt-2" id="personalInformationCheck" true-value="1" false-value="" v-model="personalInformationCheck" @click="sendSignalingInputData" :disabled="!isOperationPossible">
                      同意する
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 row px-0 mx-0 mt-3" style="border: 1px solid #dee2e6">
                  <a href="#" class="col-sm-5" style="align-items: center; display: flex; font-size: 1rem;" @click.prevent.stop="openTermPDF('imageTerm')">画像の撮影・お取り扱いについて</a>
                  <div class="col-sm-7 d-flex">
                    <label class="py-1 px-4 mr-4 mb-0" style="font-size: 1rem;" for="imageCheck">
                      <input type="checkbox" class="checkbox-scale-larger mt-2 " id="imageCheck" true-value="1" false-value="" v-model="imageCheck" @change="sendSignalingInputData" :disabled="!isOperationPossible">
                      同意する
                    </label>
                    <label class="py-1 px-4 mb-0" style="font-size: 1rem;" for="imageCheckDisagree">
                      <input type="checkbox" class="checkbox-scale-larger mt-2" id="imageCheckDisagree" true-value="1" false-value="" v-model="imageCheckDisagree" @change="sendSignalingInputData" :disabled="!isOperationPossible">
                      同意しない
                    </label>
                  </div>
                </div>
                  <div class="col-sm-12 mt-3 btn-toolbar justify-content-center">
                    <b-button class="gray-btn-disabled" @click="clearCanvas" :disabled="!isOperationPossible">キャンセル</b-button>
                    <b-button variant="outline-primary" class="btn sub-button-color ml-2 white-btn-disabled" @click="checkSign" :disabled="!isOperationPossible">サインを登録</b-button>
                  </div>
                </div>
              </transition>
            <div class="mt-5 mb-3 text-right">
              <b-button variant="outline-secondary" class="w-25 sub-button-color white-btn-disabled" @click="showSignForm" :disabled="!isOperationPossible" v-if="!isShowSignForm">サイン登録</b-button>
            </div>
              <div class="col-12 mt-5" v-if="estimateData('form', 'customerMessage')">
                <p class="mb-1">【備考欄】</p>
                <p class="border p-2 h-100 line-break">{{estimateData('form', 'customerMessage')}}</p>
              </div>
              <hr>
              <div class="p-3">
                <div v-for="(imageAndMemo, sectionL) in estimateData('imageAndMemo')" :key="'estimate_' + sectionL">
                  <p class="mb-1" v-if="sectionL === 'メインテーブル・ゲストテーブル' && (imageAndMemo['images'].length > 0 || categorizedImages['メインテーブル・ゲストテーブル'].length > 0)">
                    【メインテーブル・ゲストテーブル】
                  </p>
                  <div class="row">
                    <template v-if="sectionL === 'メインテーブル・ゲストテーブル'">
                      <!-- 既存の画像 -->
                      <template v-for="(imageObj, index) in imageAndMemo['images']">
                        <div class="col-4 mt-2 px-1" :key="'existing_' + index">
                          <div class="card-sqr-gray card-h-145px">
                            <img class="ar-3-2" :src="imageObj.body || imageObj"/>
                          </div>
                        </div>
                      </template>

                    <template v-for="(bookmarkImg, index) in categorizedBookmarkImages['メインテーブル・ゲストテーブル']">
                      <div class="col-4 mt-2 px-1" :key="'bookmark_spec_' + index">
                        <div class="card-sqr-gray card-h-145px">
                          <img class="ar-3-2" :src="bookmarkImg.image"/>
                        </div>
                      </div>
                    </template>

                      <template v-for="(uploadImg, index) in categorizedImages['メインテーブル・ゲストテーブル']">
                        <div class="col-4 mt-2 px-1" :key="'upload_spec_' + index">
                          <div class="card-sqr-gray card-h-145px">
                            <img class="ar-3-2" :src="uploadImg.image"/>
                          </div>
                        </div>
                      </template>
                    </template>

                    <template v-else>
                      <div class="col-4 mt-2 px-1" v-for="(imageObj, index) in getCombinedImages(sectionL)" :key="'combined_' + sectionL + '_' + index">
                        <div class="card-sqr-gray card-h-145px">
                          <img class="ar-3-2" :src="imageObj.body"/>
                        </div>
                      </div>
                    </template>
                    <template v-for="(memo, index) in imageAndMemo['memo']">
                      <div :class="sectionL !== 'メインテーブル・ゲストテーブル' && getCombinedImages(sectionL).length === 1 ? 'col-8 h-auto mt-3 mb-4' : 'col-12 mt-3 mb-4'" :key="'memo_' + index" v-if="memo">
                        <p class="mb-1 mt-3" v-if="index === 'メインテーブル'">【メインテーブルメモ】</p>
                        <p class="mb-1 mt-3" v-if="index === 'ゲストテーブル'">【ゲストテーブルメモ】</p>
                        <p class="border p-2 h-100 line-break">{{memo}}</p>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-if="dataReady">
                  <div v-for="sectionL in displaySections" :key="'section_' + sectionL">
                    <template v-if="sectionL === 'メイン提案'">
                      <p class="mb-1 mt-5" v-if="hasAnyCombinedImages('メイン提案', 'メインテーブル')">【メインテーブル】</p>
                    </template>
                    <template v-else-if="sectionL === 'ゲスト別種'">
                      <p class="mb-1 mt-5" v-if="hasAnyCombinedImages('ゲスト別種', 'ゲストテーブル')">【ゲストテーブル】</p>
                    </template>
                    <template v-else>
                      <p class="mb-1 mt-5" v-if="hasAnyCombinedImages(sectionL, sectionL)">【{{sectionL}}】</p>
                    </template>

                    <div class="row mb-4" v-if="hasAnyCombinedImages(sectionL, sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                      <template v-if="getSectionImages(sectionL)">
                        <template v-for="(imageSrc, index) in getSectionImages(sectionL)">
                          <div class="col-4 mt-2 px-1" :key="'existing_' + index" v-if="imageSrc['displayImage']">
                            <div class="card-sqr-gray card-h-140px">
                              <img class="ar-3-2" :src="imageSrc['image']"/>
                            </div>
                          </div>
                        </template>
                      </template>

                      <template v-for="(bookmarkImg, index) in getBookmarkImagesForSection(sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                        <div class="col-4 mt-2 px-1" :key="'bookmark_' + index">
                          <div class="card-sqr-gray card-h-140px">
                            <img class="ar-3-2" :src="bookmarkImg.image"/>
                          </div>
                        </div>
                      </template>

                      <template v-for="(uploadImg, index) in getUploadedImagesForSection(sectionL === 'メイン提案' ? 'メインテーブル' : sectionL === 'ゲスト別種' ? 'ゲストテーブル' : sectionL)">
                        <div class="col-4 mt-2 px-1" :key="'upload_' + index">
                          <div class="card-sqr-gray card-h-140px">
                            <img class="ar-3-2" :src="uploadImg.image"/>
                          </div>
                        </div>
                      </template>
                    </div>
                    <template v-if="getSectionMemo(sectionL)">
                      <template v-for="(memo, index) in getSectionMemo(sectionL)">
                        <div class="col-9 h-auto mt-2 pl-0" :key="'memo_' + index" v-if="memo">
                          <p class="mb-1">【{{sectionL}}メモ】</p>
                          <p class="border p-2 h-100 line-break">{{memo}}</p>
                        </div>
                      </template>
                    </template>
                  </div>

                  <div v-if="categorizedBookmarkImages['未分類'] && categorizedBookmarkImages['未分類'].length > 0">
                    <p class="mb-1 mt-5">【ブックマーク画像】</p>
                    <div class="row mb-4">
                      <template v-for="(bookmarkImg, index) in categorizedBookmarkImages['未分類']">
                        <div class="col-4 mt-2 px-1 estimate-img-div" :key="'uncategorized_bookmark_' + index">
                          <div class="image-container" style="position: relative;">
                            <img class="ar-3-2 w-100" :src="bookmarkImg.image" style="border: 1px solid #dee2e6; border-radius: 0.25rem;"/>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div v-if="categorizedImages['未分類'] && categorizedImages['未分類'].length > 0">
                    <p class="mb-1 mt-5">【アップロード画像】</p>
                    <div class="row mb-4">
                      <template v-for="(uploadImg, index) in categorizedImages['未分類']">
                        <div class="col-4 mt-2 px-1" :key="'uncategorized_' + index">
                          <div class="card-sqr-gray card-h-140px">
                            <img class="ar-3-2" :src="uploadImg.image"/>
                          </div>
                        </div>
                      </template>

                      <template v-if="getSectionMemo('お客様画像')">
                        <template v-for="(memo, index) in getSectionMemo('お客様画像')">
                          <div class="col-9 h-auto mt-2" :key="'memo_' + index" v-if="memo">
                            <p class="mb-1">【アップロード画像メモ】</p>
                            <p class="border p-2 h-100 line-break">{{memo}}</p>
                          </div>
                        </template>
                      </template>
                    </div>
                  </div>
                  <div v-for="(imageAndMemo, sectionL) in otherEstimateData('imageAndMemo')" :key="'history_' + sectionL">
                    <div v-if="sectionL === '変更履歴'">
                      <template v-for="(info, index) in imageAndMemo['changeHistoryInfo']">
                        <div class="row mb-4" v-if="info['images'] && info['images'].length > 0" :key="'history_' + index">
                          <template v-for="(imageSrc, imgIndex) in info['images']">
                            <div class="col-12 mt-2 px-1" :key="'himg_' + imgIndex">
                              <div class="card-sqr-gray card-h-140px">
                                <img class="ar-3-2" :src="imageSrc['image']"/>
                              </div>
                            </div>
                          </template>
                          <div class="col-9 h-auto mt-2" v-if="info['images'] && info['images'].length > 0 && info['comment']">
                            <p class="border p-2 h-100 line-break">{{info['comment']}}</p>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <b-overlay class="m-5" :show="true" rounded="sm">
                    <div style="height: 200px;"></div>
                  </b-overlay>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
      <CommonModal ref="commonModal" />
      <CommonModal ref="commonModalAgreementCheck" @confirmOk="exportDrawnImage" />
    </CustomerMeetingLayout>
  </CommonLayout>
</template>
<script>
import Vue from 'vue'
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import CommonModal from '@/components/CommonModal'
import SignDrawCanvas from '@/components/SignDrawCanvas'
import SignalingModel from '@/models/SignalingModel'
import EstimateModel from '@/models/EstimateModel'
import EstimateOtherSectionModel from '@/models/EstimateOtherSectionModel'
import SignImageRegistModel from '@/models/SignImageRegistModel'
import MeetingInfoUpdateModel from '@/models/MeetingInfoUpdateModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'
import store from '@/store/model-store'
import SimpleVueValidation from 'simple-vue-validator'
const Validator = SimpleVueValidation.Validator

Vue.use(SimpleVueValidation)

export default {
  name: 'CustomerMeetingEstimate',
  components: { CommonLayout, CustomerMeetingLayout, CommonModal, SignDrawCanvas },
  data () {
    return {
      dataReady: false,
      isOperationPossible: cstore.getters.isOperationPossible,
      isShowSignForm: false,
      overlayShow: false,
      isRegistComplete: false,
      isSendFirstSignalingData: false,
      signImageData: '',
      penColor: '#000000',
      drawMode: 'pen',
      estimateDisplayFlag: {},
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag,
      signDate: '',
      personalInformationCheck: '',
      imageCheck: '',
      imageCheckDisagree: '',
      displaySections: [
        'メイン提案',
        'ゲスト別種',
        'メインオプション',
        'ゲストオプション',
        'コーディネート',
        '演出',
        'その他装飾',
        '贈呈',
        '挙式関係',
        'ブーケ',
        'アフターブーケ'
      ],
      categoryMapping: {
        'スペック': 'メインテーブル・ゲストテーブル',
        'メイン': 'メインテーブル',
        'ゲスト': 'ゲストテーブル',
        'メインオプション': 'メインオプション',
        'ゲストオプション': 'ゲストオプション',
        'コーディネート': 'コーディネート',
        '演出': '演出',
        'その他': 'その他装飾',
        '贈呈': '贈呈',
        '挙式': '挙式関係',
        'ブーケ': 'ブーケ',
        'アフター': 'アフターブーケ'
      },
      categorizedImages: {
        'メインテーブル・ゲストテーブル': [],
        'メインテーブル': [],
        'ゲストテーブル': [],
        'メインオプション': [],
        'ゲストオプション': [],
        'コーディネート': [],
        '演出': [],
        'その他装飾': [],
        '贈呈': [],
        '挙式関係': [],
        'ブーケ': [],
        'アフターブーケ': [],
        '未分類': []
      },
      categorizedBookmarkImages: {
        'メインテーブル・ゲストテーブル': [],
        'メインテーブル': [],
        'ゲストテーブル': [],
        'メインオプション': [],
        'ゲストオプション': [],
        'コーディネート': [],
        '演出': [],
        'その他装飾': [],
        '贈呈': [],
        '挙式関係': [],
        'ブーケ': [],
        'アフターブーケ': [],
        '未分類': []
      }
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.isSendFirstSignalingData = true
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        if (newData['event'] !== 'api' && newData['event'] !== 'draw') {
          newData['user'] = 'customer'
          newData['timestampMs'] = Date.now()
          CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
          })
        }
        if (!cstore.getters.isOperationPossible) {
          // if (newData['id'] !== 'reDrawMemoImage' && this.isOperationPossible) {
          //   const synchPass = newData['current_path'].replace('florist', 'customer')
          //   if (synchPass !== this.$route.path) {
          //     return this.$router.push(synchPass)
          //   }
          // }
          if (newData['event'] === 'click') {
            if (newData['id'] === 'reload') {
              this.setApiData()
            }
            if (newData['id'] === 'showSignForm') {
              this.isShowSignForm = true
            }
            if (newData['id'] === 'clearCanvas') {
              this.$refs.signDrawCanvas.onClearCanvas()
              this.isShowSignForm = false
            }
            if (newData['id'] === 'registDrawnImage') {
              this.$refs.commonModal.msgBoxOk('サインの登録が完了しました')
              this.isShowSignForm = false
              this.setApiData(true)
              this.$refs.signDrawCanvas.onClearCanvas()
            }
            if (newData['id'] === 'changePenColor') {
              this.penColor = newData['color']
            }
            if (newData['id'] === 'changeDrawMode') {
              this.drawMode = newData['drawMode']
            }
          }
          if (newData['event'] === 'draw') {
            this.$refs.signDrawCanvas.syncDraw(newData['data'])
          }
          if (newData['event'] === 'api' && newData['api'] === 'estimateData') {
            this.setApiData(true)
          }
          if (newData['event'] === 'input') {
            console.log("newData['data']:")
            console.log(newData['data'])
            for (var i = 0; i < newData['data'].length; i++) {
              if (newData['data'][i] && newData['data'][i].id) {
                console.log(newData['data'][i])
                console.log(newData['data'][i].id)
                let elm = document.getElementById(newData['data'][i].id)
                if (!elm) {
                  continue
                }

                if (elm.getAttribute('type') === 'checkbox') {
                  elm.checked = newData['data'][i].value
                  elm.value = newData['data'][i].value ? 1 : ''
                  elm.dispatchEvent(new Event('change'))
                }
              }
            }
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            // 画面遷移時に商品一覧のスクロール位置を削除
            sessionStorage.removeItem('proposalScrollHistoryFlag')
            sessionStorage.removeItem('scrollY')
            this.$router.push(newData['target_path'])
          }
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              this.isOperationPossible = false
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              this.isOperationPossible = true
            }
          }
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }
          if (newData['id'] === 'reDrawMemoImage') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const tableRowId = 'tableRowId' in newData && newData['tableRowId'] ? newData['tableRowId'] : ''
            const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'tableRowId': tableRowId}})
          }
          if (newData['id'] === 'productDetailFromBookmark') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  validators: {
    personalInformationCheck: function (value) {
      return Validator.value(value).required(this.consts.validationMsg.meetingComfirm.personalInformationCheck.required)
    }
  },
  methods: {
    estimateData (datatype, key = null) {
      try {
        const store = EstimateModel.getStore()
        if (!store) {
          return null
        }
        return key ? store.estimate[datatype][key] : store.estimate[datatype]
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return null
      }
    },
    otherEstimateData (datatype, key = null) {
      try {
        const store = EstimateOtherSectionModel.getStore()
        if (!store) {
          return null
        }
        if (datatype === 'imageAndMemo') {
          for (const sectionL in store[datatype]) {
            for (const imageInfo in store[datatype][sectionL]['images']) {
              if (store[datatype][sectionL]['images'][imageInfo]['displayImage'] === 1) {
                this.estimateDisplayFlag[sectionL] = true
                break
              }
            }
          }
        }
        return key ? store[datatype][key] : store[datatype]
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return null
      }
    },
    setApiData: async function (isReload = false) {
      try {
        this.dataReady = false
        this.overlayShow = true
        let params = {'isIncludeImageAndMemo': 'True'}
        const resData = await EstimateModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        console.log(resData)
        // メインオプション、ゲストオプション、ゲスト別種の画像取得
        const itemInfo = []
        for (const section of ['メインテーブル', 'ゲストテーブル']) {
          // itemInfoに登録したゲスト別種のレコード番号を保持。ゲスト別種レコード番号の重複防止に利用
          const pushedMainOtherNoList = []
          const pushedGuestOtherNoList = []
          params['itemCode'] = []
          const items = resData.estimate.table[section] ? Object.keys(resData.estimate.table[section]) : []
          for (const item of items) {
            if ('mainOtherRecordNo' in resData.estimate.table[section][item]) {
              const mainOtherRecordNo = resData.estimate.table[section][item]['mainOtherRecordNo']
              const serialNo = resData.estimate.table[section][item]['serialNo']
              if (pushedMainOtherNoList.indexOf(mainOtherRecordNo + '-' + serialNo) < 0) {
                // pushedMainOtherNoListに未登録のメイン提案レコード番号の場合にitemInfoに画像取得用のパラメータをセットする
                itemInfo.push({'serialNo': serialNo, 'mainOtherRecordNo': mainOtherRecordNo, 'type': 'mainOther'})
                pushedMainOtherNoList.push(mainOtherRecordNo + '-' + serialNo)
              }
            } else if ('guestOtherRecordNo' in resData.estimate.table[section][item]) {
              const guestOtherRecordNo = resData.estimate.table[section][item]['guestOtherRecordNo']
              const serialNo = resData.estimate.table[section][item]['serialNo']
              if (pushedGuestOtherNoList.indexOf(guestOtherRecordNo + '-' + serialNo) < 0) {
                // pushedGuestOtherNoListに未登録のゲスト別種レコード番号の場合にitemInfoに画像取得用のパラメータをセットする
                itemInfo.push({'serialNo': serialNo, 'guestOtherRecordNo': guestOtherRecordNo, 'type': 'guestOther'})
                pushedGuestOtherNoList.push(guestOtherRecordNo + '-' + serialNo)
              }
            } else if (resData.estimate.table[section][item]['sectionM'] === 'メインオプション' && !('specOptionProduct' in resData.estimate.table[section][item])) {
              itemInfo.push({'serialNo': resData.estimate.table[section][item]['serialNo'], 'itemCode': resData.estimate.table[section][item]['itemCode'], 'type': 'mainOpt'})
            } else if (resData.estimate.table[section][item]['sectionM'] === 'ゲストオプション' && !('specOptionProduct' in resData.estimate.table[section][item])) {
              itemInfo.push({'serialNo': resData.estimate.table[section][item]['serialNo'], 'itemCode': resData.estimate.table[section][item]['itemCode'], 'type': 'guestOpt'})
            }
          }
        }
        if (itemInfo.length) {
          params['sectionL'] = 'メインゲストオプション別種'
          params['itemInfo'] = itemInfo
          console.log('itemInfo ↓')
          console.log(itemInfo)
          let startFlag = true
          let result = ''
          params['startNo'] = 0
          params['functionStartNo'] = 1
          let modelStore = store.getters.model
          if ('otherEstimate' in modelStore) {
            modelStore['otherEstimate']['imageAndMemo']['メインオプション'] = {}
            modelStore['otherEstimate']['imageAndMemo']['ゲストオプション'] = {}
            modelStore['otherEstimate']['imageAndMemo']['メイン提案'] = {}
            modelStore['otherEstimate']['imageAndMemo']['ゲスト別種'] = {}
          }
          while (startFlag) {
            result = await EstimateOtherSectionModel.apiSetStore(this.$bvModal, params, ['メインオプション', 'ゲストオプション', 'メイン提案', 'ゲスト別種'], () => {})
            if (params['functionStartNo'] === result['functionStartNo']) {
              params['startNo'] += result['startNo']
            } else {
              params['startNo'] = result['startNo']
            }
            params['functionStartNo'] = result['functionStartNo']
            if (result.notOverSizeFlag === true) {
              startFlag = false
            }
          }
        }
        // メインゲスト以外の商品の画像と大区分メモを取得
        let sections = Object.keys(resData.estimate.table)
        sections.push('お客様画像')
        sections.push('変更履歴')
        sections.push('ブックマーク')
        const exclusionList = ['メインテーブル', 'ゲストテーブル', '持ち帰り']
        for (const section of sections) {
          params['resData'] = []
          let sectionL = ''
          if (section !== 'お客様画像' && section !== '変更履歴' && section !== 'ブックマーク') {
            let data = resData.estimate.table[section]
            for (const i in data) {
              params['resData'].push({'itemCode': data[i]['itemCode'], 'serialNo': data[i]['serialNo']})
            }
          }
          if (section !== 'お客様画像' && section !== '変更履歴' && section !== 'ブックマーク') {
            sectionL = resData.estimate.table[section][0]['sectionL']
          } else {
            sectionL = section
          }
          params['sectionL'] = sectionL
          if (exclusionList.indexOf(sectionL) < 0) {
            // メインゲスト以外の商品画像、大区分メモを取得（持ち帰りは画像無しのため、持ち帰り以外の場合に処理実施）
            let startFlag = true
            let result = ''
            params['startNo'] = 0
            let modelStore = store.getters.model
            if ('otherEstimate' in modelStore) {
              modelStore['otherEstimate']['imageAndMemo'][sectionL] = {}
            }
            while (startFlag) {
              params['itemInfo'] = ''
              result = await EstimateOtherSectionModel.apiSetStore(this.$bvModal, params, sections, () => {})
              if (sectionL !== '変更履歴') {
                params['startNo'] += result[sectionL]['images'].length
              } else {
                params['startNo'] = result[sectionL]['startNo']
                params['imageStartNo'] = result[sectionL]['imageStartNo']
              }
              if (result.notOverSizeFlag === true) {
                startFlag = false
              }
            }
            if ((sectionL === 'お客様画像' || sectionL === 'ブックマーク') && modelStore['otherEstimate']['imageAndMemo'][sectionL]['images']) {
              modelStore['otherEstimate']['imageAndMemo'][sectionL]['images'] = this.sortBringImagesBySortOrder(
                modelStore['otherEstimate']['imageAndMemo'][sectionL]['images']
              )
            }
          }
        }
        if (resData.estimate && resData.estimate.signImage) {
          this.signImageData = resData.estimate.signImage
          this.signDate = resData.estimate.signDate
        }
        if (resData.estimate.personalInformationCheck) {
          if (resData.estimate.personalInformationCheck[0] === '同意する') {
            this.personalInformationCheck = 1
          } else {
            this.personalInformationCheck = ''
          }
        }
        if (resData.estimate.imageCheck) {
          if (resData.estimate.imageCheck === '同意する') {
            this.imageCheck = 1
            this.imageCheckDisagree = ''
          } else if (resData.estimate.imageCheck === '同意しない') {
            this.imageCheck = ''
            this.imageCheckDisagree = 1
          } else {
            this.imageCheck = ''
            this.imageCheckDisagree = ''
          }
        }
        this.categorizeUploadedImages()
        this.categorizeBookmarkImages()
        this.dataReady = true
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sortBringImagesBySortOrder (images) {
      try {
        if (!images || images.length === 0) return images
        const displayImages = images.filter(img => img.displayImage === 1)
        const toOrder = (v) => {
          // null/undefined/''/'   ' を未入力扱いにする
          if (v === null || v === undefined) return 999999
          if (typeof v === 'string' && v.trim() === '') return 999999
          const n = Number(v)
          return Number.isFinite(n) ? n : 999999
        }
        displayImages.sort((a, b) => toOrder(a.sortOrder) - toOrder(b.sortOrder))
        return displayImages
      } catch (err) {
        console.error('並び順ソートエラー:', err)
        return images
      }
    },
    showSignForm () {
      try {
        this.isShowSignForm = true
        SignalingModel.sendClickEvent('showSignForm', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    clearCanvas () {
      try {
        this.$refs.signDrawCanvas.onClearCanvas()
        this.isShowSignForm = false
        SignalingModel.sendClickEvent('clearCanvas', this)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    checkSign: async function () {
      try {
        // 同意チェックしていない場合はアラートモーダルを表示する
        if (this.personalInformationCheck === '' || (this.imageCheck === '' && this.imageCheckDisagree === '')) {
          this.$refs.commonModalAgreementCheck.msgBoxConfirm('「個人情報のお取り扱いについて」、「画像の撮影・お取り扱いについて」にて選択されていない項目があります。このまま登録を進めてよろしいですか。')
        } else {
          this.exportDrawnImage()
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    exportDrawnImage: async function () {
      try {
        this.$refs.signDrawCanvas.onExportDrawnImage()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    registDrawnImage: async function (dataURL) {
      try {
        this.overlayShow = true
        let imageFlag = ''
        if (this.imageCheck) {
          imageFlag = '01'
        } else if (this.imageCheckDisagree) {
          imageFlag = '02'
        } else {
          imageFlag = '00'
        }
        const params = {
          'signImage': dataURL.replace(/^.*,/, ''),
          'personalInformationFlag': this.personalInformationCheck ? '01' : '00',
          'imageFlag': imageFlag
        }
        const result = await SignImageRegistModel.apiSetStore(this.$bvModal, params, () => {
          this.overlayShow = false
        })
        SignalingModel.sendClickEvent('registDrawnImage', this)
        this.$refs.commonModal.msgBoxOk('サインの登録が完了しました')
        this.signImageData = dataURL
        this.isShowSignForm = false
        this.isRegistComplete = true
        this.$refs.signDrawCanvas.onClearCanvas()
        this.signDate = result['signDate']
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingDraw (position, isMousedown) {
      try {
        SignalingModel.sendDrawEvent({
          'position': position,
          'is_mousedown': isMousedown
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changePenColor (e) {
      try {
        this.penColor = e.target.value
        SignalingModel.sendClickEvent('changePenColor', this, {'color': this.penColor})
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changeDrawMode (e) {
      try {
        SignalingModel.sendClickEvent('changeDrawMode', this, {'drawMode': e.target.value})
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    toCommaSeparated (str) {
      try {
        if (str) {
          try {
            return parseInt(str, 10).toLocaleString()
          } catch (err) {
            return ''
          }
        }
        return str
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
        return null
      }
    },
    changeDateFormat (datatype, key) {
      const date = this.estimateData(datatype, key)
      if (date === null || date === '') {
        return null
      }
      const dates = date.split('-')

      if (dates.length < 3) {
        // 日付データでなければそのまま出力する
        return date
      }

      const year = dates[0]
      const month = dates[1]
      const day = dates[2]

      if (month.slice(0, 1) === 0) {
        month.slice(1)
      }
      if (day.slice(0, 1) === 0) {
        day.slice(1)
      }
      const weekData = [ '(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)' ]
      const dayInfo = new Date(year, month - 1, day)
      const result = date + weekData[dayInfo.getDay()]

      return result
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    },
    toggleAgreeButton (targetElm) {
      try {
        // 「同意する」「同意しない」チェックボックスのON/OFFを切り替える
        if (targetElm.id === 'imageCheck') {
          this.imageCheckDisagree = targetElm.checked ? '' : '1'
          document.getElementById('imageCheckDisagree').checked = !targetElm.checked
        } else {
          this.imageCheck = targetElm.checked ? '' : '1'
          document.getElementById('imageCheck').checked = !targetElm.checked
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sendSignalingInputData: function (e) {
      try {
        if (this.isOperationPossible) {
          // クリックイベントで呼び出された場合(=引数 e に値が渡されている場合)にidを取得
          const clickedElmID = e ? e.target.id : ''
          if (clickedElmID === 'imageCheck' || clickedElmID === 'imageCheckDisagree') {
            // クリックされたのが、画像利用目的の「同意する」「同意しない」チェックの場合、チェックボックストグル処理を実施
            this.toggleAgreeButton(e.target)
          }

          let sendData = []
          const checkInputs = document.querySelectorAll('input[type="checkbox"]')
          for (let i = 0; i < checkInputs.length; i++) {
            sendData.push({'id': checkInputs[i].id, 'value': checkInputs[i].checked})
          }
          // 同意チェックボックスの値をシグナリングで送信するデータにセットする
          SignalingModel.sendInputEvent(this, sendData)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    openTermPDF (key) {
      if (key === 'personalInformation') {
        window.open(this.config.personalInformationTerm, '_blank')
      }
      if (key === 'imageTerm') {
        window.open(this.config.imageTerm, '_blank')
      }
    },
    categorizeUploadedImages () {
      try {
        console.log('🔍 ===== お客様画像振り分け開始 =====')

        // 初期化
        this.categorizedImages = {
          'メインテーブル・ゲストテーブル': [],
          'メインテーブル': [],
          'ゲストテーブル': [],
          'メインオプション': [],
          'ゲストオプション': [],
          'コーディネート': [],
          '演出': [],
          'その他装飾': [],
          '贈呈': [],
          '挙式関係': [],
          'ブーケ': [],
          'アフターブーケ': [],
          '未分類': []
        }

        const otherEstimate = this.otherEstimateData('imageAndMemo')

        if (!otherEstimate || !otherEstimate['お客様画像']) {
          console.log('⚠️ お客様画像データなし')
          return
        }

        const uploadedImages = otherEstimate['お客様画像']['images'] || []
        console.log(`📊 総画像数: ${uploadedImages.length}`)

        uploadedImages.forEach((img, index) => {
          // 表示対象の画像のみ処理
          if (img.displayImage !== 1) {
            console.log(`  [${index + 1}] スキップ (displayImage=${img.displayImage})`)
            return
          }

          const category = img.category || ''
          console.log(`  [${index + 1}] カテゴリ: "${category}"`)

          // カテゴリが空の場合は「未分類」へ
          if (!category || category.trim() === '') {
            this.categorizedImages['未分類'].push({
              ...img,
              originalCategory: '',
              mappedFrom: '未分類'
            })
            console.log(`    → "未分類" に振り分け`)
            return
          }

          // カンマ区切りで複数カテゴリに対応
          const categories = category.split(',').map(c => c.trim()).filter(c => c)
          if (categories.length === 0) {
            this.categorizedImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
            console.log(`    → "未分類" に振り分け (空白のみ)`)
            return
          }

          let mappedCount = 0

          // カテゴリマッピングに従って振り分け
          categories.forEach(cat => {
            const mappedSection = this.categoryMapping[cat]

            if (mappedSection && this.categorizedImages[mappedSection]) {
              this.categorizedImages[mappedSection].push({
                ...img,
                originalCategory: category,
                mappedFrom: cat
              })
              console.log(`    🔄 "${cat}" → "${mappedSection}" に振り分け`)
              mappedCount++
            } else {
              console.log(`    ⚠️ "${cat}" は未対応カテゴリ`)
            }
          })

          // どのカテゴリにもマッピングされなかった場合は「未分類」へ
          if (mappedCount === 0) {
            this.categorizedImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
            console.log(`    → "未分類" に振り分け (未対応カテゴリ)`)
          }
        })

        // 結果をログ出力
        console.log('\n🔍 ===== 振り分け結果 =====')
        Object.keys(this.categorizedImages).forEach(key => {
          const count = this.categorizedImages[key].length
          if (count > 0) {
            console.log(`  ${key}: ${count}枚`)
            this.categorizedImages[key].forEach((img, idx) => {
              console.log(`    [${idx + 1}] ${img.name || '名前なし'} (元: ${img.originalCategory})`)
            })
          }
        })
        console.log('🔍 ===== 振り分け完了 =====\n')
      } catch (err) {
        console.error('❌ お客様画像振り分けエラー:', err)
        CommonLogModel.apiSetStore(this.$bvModal, {
          'timestampMs': Date.now(),
          'error': err,
          'location': 'categorizeUploadedImages'
        }, () => {})
      }
    },
    categorizeBookmarkImages () {
      try {
        // 初期化
        this.categorizedBookmarkImages = {
          'メインテーブル・ゲストテーブル': [],
          'メインテーブル': [],
          'ゲストテーブル': [],
          'メインオプション': [],
          'ゲストオプション': [],
          'コーディネート': [],
          '演出': [],
          'その他装飾': [],
          '贈呈': [],
          '挙式関係': [],
          'ブーケ': [],
          'アフターブーケ': [],
          '未分類': []
        }

        const otherEstimate = this.otherEstimateData('imageAndMemo')

        if (!otherEstimate || !otherEstimate['ブックマーク']) {
          // ブックマークデータなし
          return
        }
        const bookmarkImages = otherEstimate['ブックマーク']['images'] || []

        bookmarkImages.forEach((img, index) => {
          // 表示対象の画像のみ処理
          if (img.displayImage !== 1) {
            return
          }

          const category = img.category || ''

          if (!category || category.trim() === '') {
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: '',
              mappedFrom: '未分類'
            })
            return
          }

          // カンマ区切りで複数カテゴリに対応
          const categories = category.split(',').map(c => c.trim()).filter(c => c)

          if (categories.length === 0) {
            // 空白文字のみの場合も「未分類」へ
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
            return
          }
          let mappedCount = 0
          // カテゴリマッピングに従って振り分け
          categories.forEach(cat => {
            const mappedSection = this.categoryMapping[cat]

            if (mappedSection && this.categorizedBookmarkImages[mappedSection]) {
              this.categorizedBookmarkImages[mappedSection].push({
                ...img,
                originalCategory: category,
                mappedFrom: cat
              })
              mappedCount++
            }
          })
          // どのカテゴリにもマッピングされなかった場合は「未分類」へ
          if (mappedCount === 0) {
            this.categorizedBookmarkImages['未分類'].push({
              ...img,
              originalCategory: category,
              mappedFrom: '未分類'
            })
          }
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {
          'timestampMs': Date.now(),
          'error': err,
          'location': 'categorizedBookmarkImages'
        }, () => {})
      }
    },
    getSectionImages (sectionL) {
      try {
        const otherEstimate = this.otherEstimateData('imageAndMemo')
        if (!otherEstimate || !otherEstimate[sectionL]) {
          return []
        }
        return otherEstimate[sectionL]['images'] || []
      } catch (err) {
        console.error(`❌ getSectionImages(${sectionL}) エラー:`, err)
        return []
      }
    },
    getSectionMemo (sectionL) {
      try {
        const otherEstimate = this.otherEstimateData('imageAndMemo')
        if (!otherEstimate || !otherEstimate[sectionL]) {
          return []
        }
        return otherEstimate[sectionL]['memo'] || []
      } catch (err) {
        console.error(`❌ getSectionMemo(${sectionL}) エラー:`, err)
        return []
      }
    },
    getUploadedImagesForSection (sectionL) {
      try {
        // メイン提案 → メインテーブル、ゲスト別種 → ゲストテーブルの変換
        let targetSection = sectionL
        if (sectionL === 'メイン提案') {
          targetSection = 'メインテーブル'
        } else if (sectionL === 'ゲスト別種') {
          targetSection = 'ゲストテーブル'
        }

        return this.categorizedImages[targetSection] || []
      } catch (err) {
        console.error(`❌ getUploadedImagesForSection(${sectionL}) エラー:`, err)
        return []
      }
    },
    getBookmarkImagesForSection (sectionL) {
      try {
        // メイン提案 → メインテーブル、ゲスト別種 → ゲストテーブル の変換
        let targetSection = sectionL
        if (sectionL === 'メイン提案') {
          targetSection = 'メインテーブル'
        } else if (sectionL === 'ゲスト別種') {
          targetSection = 'ゲストテーブル'
        }

        return this.categorizedBookmarkImages[targetSection] || []
      } catch (err) {
        console.error('ブックマーク画像取得エラー:', err)
        return []
      }
    },
    hasAnyCombinedImages (otherEstimateSectionL, uploadedImageSectionL) {
      try {
        // 既存画像の存在チェック
        const existingImages = this.getSectionImages(otherEstimateSectionL)
        const hasExisting = existingImages.some(img => img['displayImage'] === 1)

        // お客様画像の存在チェック
        const hasUploaded = this.getUploadedImagesForSection(uploadedImageSectionL).length > 0

        // ブックマーク画像の存在チェック
        const hasBookmark = this.getBookmarkImagesForSection(uploadedImageSectionL).length > 0

        return hasExisting || hasUploaded || hasBookmark
      } catch (err) {
        console.error('❌ hasAnyCombinedImagesエラー:', err)
        return false
      }
    },
    getCombinedImages (sectionL) {
      try {
        const combinedImages = []

        // 既存の画像を取得
        const estimateImages = this.estimateData('imageAndMemo')
        if (estimateImages && estimateImages[sectionL]) {
          const images = estimateImages[sectionL]['images'] || []
          images.forEach(img => {
            combinedImages.push({
              source: 'estimate',
              body: img['body'] || img,
              isUploadedImage: false
            })
          })
        }

        // お客様画像を追加
        const uploadedImages = this.categorizedImages[sectionL] || []
        uploadedImages.forEach(img => {
          combinedImages.push({
            source: 'uploaded',
            body: img.image,
            category: img.originalCategory,
            sortOrder: img.sortOrder,
            name: img.name,
            isUploadedImage: true
          })
        })

        // 3. ブックマーク画像を追加
        const bookmarkImages = this.categorizedBookmarkImages[sectionL] || []
        bookmarkImages.forEach(img => {
          combinedImages.push({
            source: 'bookmark',
            body: img.image,
            category: img.originalCategory,
            name: img.name,
            isUploadedImage: false
          })
        })

        return combinedImages
      } catch (err) {
        console.error('❌ 画像結合エラー:', err)
        return []
      }
    }
  },
  created () {
    const lastRoutePath = sessionStorage.getItem('lastRoutePath')
    if (lastRoutePath !== this.$route.path) {
      // 初期状態でtrue
      cstore.commit('setIsOperationPossible', true)
      this.isOperationPossible = true
      // 権限の情報をdynamoDBに登録
      const updateData = {
        'operatingPrivilege': '1',
        'attendeeType': this.consts.attendeeType.customer
      }
      MeetingInfoUpdateModel.apiSetStore(this.$bvModal, updateData, () => {})
    }
    if (sessionStorage.customerType === this.consts.customerType.guest) {
      // ゲストカスタマーの場合はfalse
      cstore.commit('setIsOperationPossible', false)
      this.isOperationPossible = false
    }
  },
  mounted () {
    try {
      this.setApiData()
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  },
  destroyed () {
    try {
      if (SignImageRegistModel.getStore()) {
        SignImageRegistModel.removeStore()
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style>
.white-btn-disabled:disabled {
  color: rgb(0, 123, 255) !important;
  border-color: rgb(0, 123, 255) !important;
  background-color: #fff !important;
  opacity: 1 !important;
}
.gray-btn-disabled:disabled {
  color: #fff !important;
  background-color: rgb(108, 117, 125) !important;
  opacity: 1 !important;
}
.word-pre-wrap{
    white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingEstimate.vue